module.exports = __webpack_public_path__ + "static/media/SubmittedTwentyFive.56da2047.png";